import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";
import {
  addProductStyleAsync,
  addProductProductTypeAsync,
  deleteProductProductTypeAsync,
  editProductStyleAsync,
  editProductProductTypeAsync,
  getProductStyleAsync,
  getProductProductTypeAsync,
} from "../../../../store/services/productInfoServices";
const ProductType = () => {
  const dispatch = useDispatch();
  const {
    getProductProductTypeStatus,
    getProductProductTypeError,
    getProductProductTypeData,
    addProductProductTypeStatus,
    addProductProductTypeData,
    addProductProductTypeError,

    editProductProductTypeStatus,
    editProductProductTypeError,
    editProductProductTypeData,

    deleteProductProductTypeData,
    deleteProductProductTypeStatus,
    deleteProductProductTypeError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductProductTypeAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductProductTypeData?.length
    ? getProductProductTypeData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedProductType, setSelectedProductType] = useState();
  const [addProductTypeMode, setAddProductTypeMode] = useState(false);
  const [addProductTypeData, setAddProductTypeData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedProductType", selectedProductType);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductProductTypeStatus === asyncStatus.SUCCEEDED) {
      setAddProductTypeMode(false);
      setSaveDisabled(true);
      setAddProductTypeData();
    }
  }, [, addProductProductTypeStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductProductTypeAsync(selectedProductType?.product_type_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductProductTypeStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedProductType();
    }
  }, [, deleteProductProductTypeStatus]);
  useEffect(() => {
    if (editProductProductTypeStatus === asyncStatus.SUCCEEDED) {
      setSelectedProductType();
      setEditMode(false);
    }
  }, [, editProductProductTypeStatus]);
console.log("getProductProductTypeData",getProductProductTypeData,editProductProductTypeData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this ProductType?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Product Type"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Product Type Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddProductTypeMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addProductTypeMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addProductTypeMode || !selectedProductType}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddProductTypeMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addProductTypeMode || !selectedProductType}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductProductTypeStatus === asyncStatus.LOADING ||
                  editProductProductTypeStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addProductTypeData) {
                    dispatch(addProductProductTypeAsync(addProductTypeData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedProductType, ...editData };
                    delete a.id;
                    dispatch(editProductProductTypeAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "product_type_id", headerName: "ID", flex: true },
                  {
                    field: "product_type_name",
                    headerName: "Product Type Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedProductType(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductProductTypeStatus === asyncStatus.IDLE ||
                  getProductProductTypeStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addProductTypeMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Product Type:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddProductTypeData({
                            ...addProductTypeData,
                            product_type_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddProductTypeData({
                            ...addProductTypeData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedProductType ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedProductType?.product_type_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "ProductType:",
                    comp: (
                      <InputComp
                        key={selectedProductType?.product_type_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            product_type_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedProductType?.product_type_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedProductType?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedProductType?.is_active ? true : false
                        }
                        checked={selectedProductType?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any product type</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductProductTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductProductTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductProductTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductProductTypeError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedProductType(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedProductType(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default ProductType;
